import * as React from "react";
import { SVGProps } from "react";
export const CloudFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5 16C3.88867 16 2.94433 15.611 2.167 14.833C1.389 14.0557 1 13.1113 1 12C1 10.9447 1.361 10.0313 2.083 9.26C2.80567 8.48933 3.68767 8.06933 4.729 8C5.04833 6.81933 5.69067 5.85767 6.656 5.115C7.62133 4.37167 8.736 4 10 4C11.4307 4 12.6737 4.48267 13.729 5.448C14.7843 6.41333 15.3747 7.59733 15.5 9C16.472 9 17.2983 9.34033 17.979 10.021C18.6597 10.7017 19 11.528 19 12.5C19 13.472 18.6597 14.2983 17.979 14.979C17.2983 15.6597 16.472 16 15.5 16H5Z"
            fill="currentColor"
        />
    </svg>
);
CloudFillIcon.displayName = "CloudFillIcon";
